// The middleware root the widget calls (also re-exported by lib/api). Kept in
// its own module so a caller that only needs a URL does not pull in the axios
// client.

// window.ideaLibraryRootUrl is set by setEnvironmentFromUrl() at index.jsx:275,
// which runs AFTER this module's imports are evaluated — so it can't be read at
// module scope (mirrors useSessionImageJobs.js:39-45's readSocketRoot()). Read
// it lazily, at call time, stripping trailing slashes AND a trailing "/api"
// defensively (the global has been seen both with and without the suffix).
export function getMwRoot(): string {
  return String(window.ideaLibraryRootUrl || "")
    .replace(/\/+$/, "")
    .replace(/\/api$/, "");
}

// Our gated asset routes can come back host-less ("/api/f/<id>",
// "/api/studio-files/blob/<path>"): a user-uploaded avatar's preview on a job
// row is stored that way, and only the gated-mode rewrite makes it absolute.
// Relative to the studio page it would 404 — resolve it against the root.
// Anything else (absolute, blob:, data:) is returned as is; nothing → "".
export function withMwRoot(url: string | null | undefined): string {
  if (!url) return "";
  if (!/^\/api\//.test(url)) return url;
  const root = getMwRoot();
  return root ? `${root}${url}` : url;
}
